/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Credentials_SuccessInputs */

const es_tools_nexata_list_credentials_success = /** @type {(inputs: Tools_Nexata_List_Credentials_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraciones verificadas`)
};

const en_tools_nexata_list_credentials_success = /** @type {(inputs: Tools_Nexata_List_Credentials_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations checked`)
};

/**
* | output |
* | --- |
* | "Integrations checked" |
*
* @param {Tools_Nexata_List_Credentials_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_credentials_success = /** @type {((inputs?: Tools_Nexata_List_Credentials_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Credentials_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_credentials_success(inputs)
	return en_tools_nexata_list_credentials_success(inputs)
});
export { tools_nexata_list_credentials_success as "tools.nexata.list_credentials_success" }